import { render, staticRenderFns } from "./logisticsOrderList.vue?vue&type=template&id=53496f06&scoped=true"
import script from "./logisticsOrderList.vue?vue&type=script&lang=js"
export * from "./logisticsOrderList.vue?vue&type=script&lang=js"
import style0 from "./logisticsOrderList.vue?vue&type=style&index=0&id=53496f06&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53496f06",
  null
  
)

export default component.exports